<div class="navbar-header" style="width:40%; height:40%; margin:auto;">
  <img class="responsive" style="width:100%;height: auto;" src="assets/images/Noble.png">
</div>
<section id="header" class="rounded" style="margin-top:1%;background-color:white;text-align: center;text-emphasis-color: inherit"><strong></strong>
  <div class="container">
      <div class="row" >
          <div class="col-md-12 col-xs-12 col-centered" style="align-items: center;
          text-decoration: underline;">
          <strong>PAYMENT DETAILS</strong></div>
      </div>
  </div>
</section>
<div class="card" style="margin-top: 1%">
<h4 class="card-header">Fee Receipt</h4>
<div class="card-body"  >


      <div class="col-md-6" style="float: left;">

        <div class="form-group paymentMsgDiv">
          <strong> <label for="mobileNo"> Customer Name :</label></strong> {{receiptData.name}}
        </div>
        
       <div class="form-group paymentMsgDiv">
         <strong> <label for="mobileNo"> Transaction Id :</label></strong> {{receiptData.transaction_id}}
       </div>
          <div class="form-group">
             <strong> <label for="mobileNo" >Payment Amount:</label></strong> {{receiptData.payment_amount}}
          </div>
          <div class="form-group">
              <strong> <label for="mobileNo"> Payment Status :</label></strong> {{receiptData.payment_status}}
          </div>
          <div class="form-group paymentMsgDiv">
            <strong> <label for="mobileNo"> Payment Message :</label></strong> {{receiptData.payment_message}}
            <mat-icon  *ngIf="failedPayment" class="failedPaymentIcon">cancel</mat-icon>
            <mat-icon  *ngIf="!failedPayment" class="successPaymentIcon">check_circle</mat-icon>
        </div>
        <div style="display: flex;width: 400px;justify-content: space-evenly;">
               <div class="errBackButtonDiv" style="width: 129px !important; margin-top: 30px;
               margin-bottom: 20px;">
                 <button style="font-size: 13px !important;" class="errBackButton" mat-raised-button (click)="redirectHome()" color="primary">BACK TO HOME</button>
               </div>
               <div class="errBackButtonDiv" *ngIf="receiptData.payment_status !== 'FAILED'" style="width: 129px !important; margin-top: 30px;
               margin-bottom: 20px;">
                 <button style="font-size: 13px !important;" class="errBackButton" mat-raised-button (click)="downloadQrTxnReceipt()" color="primary">DOWNLOAD</button>
               </div>
        </div>
      </div>

</div>
</div>
